import $ from 'jquery';
import 'slick-carousel';
var enquire = require('enquire.js');
require('../components/autocomplete');
require('../components/basic-search');
require('jquery-match-height');

$(document).on('click', '.question', function(event){
    event.preventDefault();
    $(this).toggleClass('open');
    $(this).next('.answer').slideToggle();
    $(this).next('.answer').toggleClass('open');
});

enquire.register("screen and (min-width: 575px)", {
    match : function() {
        $('.info-badges .badge-container .image').matchHeight();
        $('.info-badges .badge-container .title').matchHeight();
        $('.info-badges .badge-container .number').matchHeight();
        $('.info-badges .badge-container .description').matchHeight();
    },
    unmatch : function() {
        $('.info-badges .badge-container .image').matchHeight('remove');
        $('.info-badges .badge-container .title').matchHeight('remove');
        $('.info-badges .badge-container .number').matchHeight('remove');
        $('.info-badges .badge-container .description').matchHeight('remove');
    },
});


$('.info-badges').slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
        {
            breakpoint: 575,
            settings: {
            slidesToShow: 1,
            slidesToScroll: 1
            }
        }
        ]
    });

    $(window).on('load', function() {
        window.equalheight('.featured-properties .equalheight');
        window.equalheight('.featured-properties .featured-property a');
        window.equalheight('.search-result-item a');
        window.equalheight('.search-result-item .dashboard-listing');
        window.equalheight('.dashboard-listing .teaser-container .equalheight');
        window.equalheight('.premium-listing .teaser-container .equalheight');
    });

    $(window).resize(function(){
        window.equalheight('.featured-properties .equalheight');
        window.equalheight('.featured-properties .featured-property a');
        window.equalheight('.search-result-item a');
        window.equalheight('.search-result-item .dashboard-listing');
        window.equalheight('.dashboard-listing .teaser-container .equalheight');
        window.equalheight('.premium-listing .teaser-container .equalheight');
    });
